<template>
  <v-container fluid id="services" style="padding: 0">
    <v-row no-gutters class="page-section" style="padding: 30px 0 50px;">
      <v-container>
        <v-row no-gutters justify="center" class="text-center">
          <div style="width: 100%;"><h2 class="display-2 font-weight-black">{{$t('services.title')}}</h2></div>
          <div><h3 class="subtitle-1 font-italic font-weight-light">{{$t('services.text')}}</h3></div>
        </v-row>
      </v-container>
    </v-row>

    <v-row align="center" justify="center" class="text-center services-sign">
      <img src="../assets/service_import_sign.png" width="60" height="60">
    </v-row>
    <v-row class="page-section" style="margin-top: -30px; margin-bottom: 30px; padding-bottom: 30px">
      <v-container>
        <v-row justify="center" class="text-center" style="margin-bottom: 30px">
          <h1>{{$t('services.import.title')}}</h1>
        </v-row>

        <v-row justify="center" class="text-center">
          <v-col style="padding: 0 30px">
            <v-col class="services-text">
              {{$t('services.import.text1')}}
            </v-col>
            <v-col class="services-text">
              {{$t('services.import.text2')}}
            </v-col>
            <v-col class="services-text">
              {{$t('services.import.text3')}}
            </v-col>
          </v-col>
          <v-col style="padding: 0 30px">
            <v-col class="services-text">
              {{$t('services.import.text4')}}
            </v-col>
            <v-col class="services-text">
              {{$t('services.import.text5')}}
            </v-col>
            <v-col class="services-text">
              {{$t('services.import.text6')}}
            </v-col>
          </v-col>
          <v-col style="padding: 0 30px">
            <v-col class="services-text">
              {{$t('services.import.text7')}}
            </v-col>
            <v-col class="services-text">
              {{$t('services.import.text8')}}
            </v-col>
            <v-col class="services-text">
              {{$t('services.import.text9')}}
            </v-col>
          </v-col>
        </v-row>
      </v-container>
    </v-row>

    <v-row align="center" justify="center" class="text-center services-sign" style="margin-top: -80px">
      <img src="../assets/service_export_sign.png" width="70" height="70" style="margin-right: -7px">
    </v-row>
    <v-row class="page-section" style="margin-top: -30px">
      <v-container>
        <v-row justify="center" class="text-center" style="margin-bottom: 30px">
          <h1>{{$t('services.export.title')}}</h1>
        </v-row>

        <v-row justify="center" class="text-center">
          <v-col style="padding: 0 30px">
            <v-col class="services-text">
              {{$t('services.export.text1')}}
            </v-col>
            <v-col class="services-text">
              {{$t('services.export.text2')}}
            </v-col>
            <v-col class="services-text" v-if="$i18n.locale === 'en'">
              {{$t('services.export.text7')}}
            </v-col>
          </v-col>
          <v-col style="padding: 0 30px">
            <v-col class="services-text">
              {{$t('services.export.text3')}}
            </v-col>
            <v-col class="services-text">
              {{$t('services.export.text4')}}
            </v-col>
            <v-col class="services-text" v-if="$i18n.locale === 'en'">
              {{$t('services.export.text8')}}
            </v-col>
          </v-col>
          <v-col style="padding: 0 30px">
            <v-col class="services-text">
              {{$t('services.export.text5')}}
            </v-col>
            <v-col class="services-text">
              {{$t('services.export.text6')}}
            </v-col>
          </v-col>
        </v-row>
      </v-container>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'Services'
  }
</script>

<style scoped>
  #services {
  }

  .services-sign {
    position: relative;
    left: 50%;
    margin-left: -50px;
    margin-top: -50px;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background-color: #ffffff;
  }

  .services-text {
    border-top: 1px solid #2f517e;
    padding: 20px 0;
  }
</style>
